var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-album-container"},[(_vm.loading)?_c('div',[_vm._v("Loading...")]):_vm._e(),(_vm.loadingError)?_c('div',[_vm._v("There was an error: "+_vm._s(_vm.loadingError.message))]):_vm._e(),(_vm.album)?_c('div',[_c('ViewAlbum',{attrs:{"album":_vm.album,"user":_vm.user}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }